import orders from './orders';
import options from './options';
import positions from './positions';

export const handlers = [...options, ...orders, ...positions] as any;
